import { useContext, useMemo } from "react";
import { AuthContext, AppContext } from "@CONTEXTS";
import { Button, Menu, Dropdown, Modal, message, Tooltip } from "antd";
import { deleteProduct } from "@PRODUCTS";
import { addProductToDeliveryForm } from "@HELPERS";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import {
  AiFillDelete,
  AiOutlineEdit,
  AiOutlineDown,
  AiOutlineUserAdd,
} from "react-icons/ai";
import { BsThreeDotsVertical } from "react-icons/bs";

const { confirm } = Modal;

const useLogics = ({
  onLoading,
  mutate,
  fieldName,
  form,
  onClose,
  setStep,
  setUpdateValues,
  isReturned,
  setDeliveryType,
  setDesi,
}) => {
  const { info } = useContext(AuthContext);
  const { options } = useContext(AppContext);

  const confirmDelete = async (id) => {
    if (!info.authorities.includes("PRODUCT_DELETE")) {
      return message.error("Ürün silme yetkiniz bulunmamaktadır!");
    }
    confirm({
      title: "Silmek İstediğinize emin misiniz?",
      icon: <ExclamationCircleOutlined />,
      content:
        "Ürünü silmek istediğinizden emin misiniz? Onaylarsanız kalıcı olarak silinecektir. Devam etmek istiyor musunuz?",
      onOk() {
        return new Promise(async (resolve) => {
          onLoading(true);
          const response = await deleteProduct([id]);
          if (response) {
            mutate();
          }
          onLoading(false);
          resolve();
        });
      },
      onCancel() {},
    });
  };

  const menu = (record) => {
    return (
      <Menu>
        <Menu.Divider />
        <Menu.Item
          key="1"
          icon={<AiOutlineUserAdd style={{ marginRight: 5 }} />}
          onClick={(e) => {
            e.domEvent.stopPropagation();

            addProductToDeliveryForm({
              form,
              fieldName,
              record,
              desiOptions: isReturned
                ? options["DESI_RETURNED_TMH"]
                : options["DESI_TMH"],
              setDeliveryType,
              setDesi,
              syncTotalParcels: info?.specialTags?.includes("B2BPRO"),
            });
            onClose();
          }}
        >
          Seç
        </Menu.Item>
        {info.authorities.includes("PRODUCT_UPDATE") && (
          <Menu.Item
            key="2"
            icon={<AiOutlineEdit style={{ marginRight: 5 }} />}
            onClick={(e) => {
              if (!info.authorities.includes("PRODUCT_UPDATE")) {
                return message.error(
                  "Ürün düzenleme yetkiniz bulunmamaktadır!"
                );
              }
              e.domEvent.stopPropagation();
              setUpdateValues(record);
              setStep("UPDATE");
            }}
          >
            Düzenle
          </Menu.Item>
        )}
        {info.authorities.includes("PRODUCT_DELETE") && (
          <Menu.Item
            key="6"
            danger
            icon={<AiFillDelete style={{ marginRight: 5 }} />}
            onClick={(e) => {
              e.domEvent.stopPropagation();
              confirmDelete(record.id);
            }}
          >
            Sil
          </Menu.Item>
        )}
      </Menu>
    );
  };

  const columns = useMemo(() => {
    const cols = [
      {
        title: "Kod",
        key: "code",
        dataIndex: "code",
        width: 150,
        render: (text) => {
          if (text && text?.length > 40) {
            return (
              <Tooltip title={text} placement="topLeft">
                {`${text?.substring(0, 40)}...`}
              </Tooltip>
            );
          }
          return text;
        },
      },
      {
        title: "Malzeme/Ürün Adı",
        key: "name",
        dataIndex: "name",
        width: 150,
        render: (text) => {
          if (text && text?.length > 40) {
            return (
              <Tooltip title={text} placement="topLeft">
                {`${text?.substring(0, 40)}...`}
              </Tooltip>
            );
          }
          return text;
        },
      },
      {
        title: "En x Boy x Yükseklik",
        key: "width",
        dataIndex: "width",
        width: 150,
        render: (_, row) => {
          return `${row.width} x ${row.length} x ${row.height}`;
        },
      },

      {
        title: "Desi",
        key: "desi",
        dataIndex: "desi",
        width: 150,
      },
    ];

    if (
      info.authorities.includes("PRODUCT_UPDATE") &&
      info.authorities.includes("PRODUCT_DELETE")
    ) {
      cols.push({
        title: "İşlemler",
        width: 90,
        render: (_, record) => (
          <Dropdown overlay={menu(record)} placement="bottomRight">
            <Button type="link" size="small" block>
              <BsThreeDotsVertical />
            </Button>
          </Dropdown>
        ),
      });
    }

    return cols;
  }, [info, options]);

  const excelColumns = [];
  const searchKeys = [];
  return { columns, excelColumns, searchKeys };
};

export default useLogics;
